import React, { useEffect, useState } from 'react';
import classes from "./StarterScreen.module.css";
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header';
import SmallLoader from '../../components/Loaders/SmallLoader';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaCheck } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { ResetTime } from '../../store/slices/timeSlice';
import { resetQuestions } from '../../store/slices/questionsSlice';
import { ResetIndex } from '../../store/slices/indexSlice';
import { resetOpponentScore } from '../../store/slices/opponentPlayerSlice';
import { resetUserScore } from '../../store/slices/userPlayerSlice';

const StarterScreen = () => {
    const { t } = useTranslation();
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [extRef, setExtRef] = useState(null);
    const [termsModal, setTermsModal] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const [pack, setPack] = useState("Daily");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    useEffect(() => {
        if (userToken) {
            navigate("/home");
        }
    }, [userToken]);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const handlePlayClick = async (e) => {
        try {
            setLoading(true);

            setTimeout(() => {
                setLoading(false);
            }, 3000);

            dispatch(ResetTime());
            dispatch(resetQuestions());
            dispatch(ResetIndex());
            dispatch(resetOpponentScore());
            dispatch(resetUserScore());
            navigate("/game")

        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);
            // if (error?.response?.data?.status == 1) {
            //     toast.error(t("126"));
            // }
            // else if (error?.response?.data?.status == 2) {
            //     toast.error(t("125"));
            // }
            // else {
            toast.error(t("86"));
            // }
        }
    }

    return (
        <>
            <Header />

            <div className={classes.container}>
                <div className={classes.sub_container}>

                    <h1 className={classes.heading}>
                        <span style={{ color: '#EE3124' }}>Quiz Masters</span>{" "}{t("128")}
                    </h1>

                    <button type="button"
                        onClick={handlePlayClick}
                        disabled={loading}
                        className={classes.login_btn}>{
                            loading ? <SmallLoader style={{ border: "5px solid #fff" }} /> : t("129")
                        }</button>
                </div>

                <div className={classes.section_carousel_marquee}>
                    <div className={classes.section_carousel_sub_container}>
                        {data.map((item, index) => {
                            return (
                                <div key={index} className={classes.section_carousel_item}>
                                    <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                </div>
                            )
                        })}

                        {data.map((item, index) => {
                            return (
                                <div key={index} className={classes.section_carousel_item}>
                                    <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                </div>
                            )
                        })}
                    </div>
                </div>

                <div className={classes.container_2}>
                    <h1 className={classes.heading_orbito}>{t("130")}</h1>

                    <div className={classes.feature_container}>
                        {/* <img src="" alt="" className={classes.feature_image} /> */}
                        <h1 className={classes.feature_title}>{t("131")}</h1>
                        <p className={classes.feature_desc}>{t("132")}</p>
                    </div>

                    <div className={classes.feature_container}>
                        {/* <img src="" alt="" className={classes.feature_image} /> */}
                        <h1 className={classes.feature_title}>{t("133")}</h1>
                        <p className={classes.feature_desc}>
                            {t("134")}
                        </p>
                    </div>

                    <div className={classes.feature_container}>
                        {/* <img src="" alt="" className={classes.feature_image} /> */}
                        <h1 className={classes.feature_title}>{t("135")}</h1>
                        <p className={classes.feature_desc}>{t("136")}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default StarterScreen;

const data = [
    { image_link: "/assets/images/carousel/1.png" },
    { image_link: "/assets/images/carousel/2.png" },
    { image_link: "/assets/images/carousel/3.png" },
    { image_link: "/assets/images/carousel/4.png" },
    { image_link: "/assets/images/carousel/5.png" },
    { image_link: "/assets/images/carousel/6.png" },
    { image_link: "/assets/images/carousel/7.png" },
    { image_link: "/assets/images/carousel/8.png" },
    { image_link: "/assets/images/carousel/9.png" },
    { image_link: "/assets/images/carousel/10.png" },

    { image_link: "/assets/images/carousel/1.png" },
    { image_link: "/assets/images/carousel/2.png" },
    { image_link: "/assets/images/carousel/3.png" },
    { image_link: "/assets/images/carousel/4.png" },
    { image_link: "/assets/images/carousel/5.png" },
    { image_link: "/assets/images/carousel/6.png" },
    { image_link: "/assets/images/carousel/7.png" },
    { image_link: "/assets/images/carousel/8.png" },
    { image_link: "/assets/images/carousel/9.png" },
    { image_link: "/assets/images/carousel/10.png" },

];